<div class="valores-container">
  <div class="valor-item">
    <div class="valor-titulo">Total Bruto: R$ {{totalBruto | number:'1.2-2'}}</div>
  </div>
  <div class="valor-item">
    <div class="valor-titulo">Total Líquido: R$ {{totalLiquido | number:'1.2-2'}}</div>
    <div class="valor-subtitulo" *ngIf="descontosItens > 0 || descontoAdicional > 0 || descontoUnitario > 0">
      <div *ngIf="descontoUnitario > 0">Desc. unitário: <strong>R$ {{descontoUnitario | number:'1.2-2'}}</strong></div>
      <div *ngIf="descontosItens > 0">Desc. itens: <strong>R$ {{descontosItens | number:'1.2-2'}}</strong></div>
      <div *ngIf="descontoAdicional > 0">Desc. adicional: <strong>R$ {{descontoAdicional | number:'1.2-2'}}</strong></div>
    </div>
  </div>
</div>
